import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RefreshIcon(props: IconProps) {
    return <Icon {...props} iconKey={"refresh"}/>
}
